@if (currentData.showView && currentData.filterData.length > 0) {
  <div>
    <div class="kx-radio-main-wrapper">
      @for (data of currentData.filterData; track data) {
        <label class="kx-radio-wrapper mr-3">{{data.package_name}}
          <input type="radio" [value]="data.id" [id]="data.id" [checked]="isRadioSelected(data.id)" (change)="valueChange(data)">
          <span class="kx-radio-check"></span>
        </label>
      }
    </div>
  </div>
}